<template>
  <div class="successPage">
    <div class="successPage_box">
      <div class="imgbox">
        <img src="../../../../../assets/img/success.png" alt="">
      </div>
      <div class="content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Success',
}
</script>
 <style scoped lang='scss'>
 .successPage{
  width: 100%;
  margin: 0 auto;
  text-align: center;
  .successPage_box{
    padding-top: 5%;
  }
}
 </style>

